<template>
	<div>
		<slot />
	</div>
</template>

<script>

export default {
	name: 'blog-content',

	mixins: [
	],

	computed: {
	},

	methods: {
	},

	data() {
		return {
		}
	},

	created() {
	},

	destroyed() {
	},

	mounted() {
	}
}
</script>
